import Highway from '@dogstudio/highway';
import $ from 'jquery';
import { fabric } from "fabric";
import HMS from "canvas-hms";
import { gsap } from 'gsap';
class Photobooth extends Highway.Renderer {
	// Hooks/methods
	onEnter() {
		
	}
	onLeave() {}
	onEnterCompleted() {
        
    }
	onLeaveCompleted() {}
}
export default Photobooth;